/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { Toggle } from '@pointfive/ui';
import { SettingsSection } from '@/screens/settings';
import type { ViewModel } from './view-model';

export function SettingsView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '24px 12px 40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {' '}
      <div></div>{' '}
      <div style={{ display: 'grid', gridTemplateColumns: '200px 1fr', gap: '18px', alignItems: 'start' }}>
        {' '}
        <nav style={{ display: 'flex', flexDirection: 'column', gap: '2px', position: 'sticky', top: '0' }}>
          {' '}
          {(m.setNav ?? []).map((i, i176) => (
            <Fragment key={i176}>
              <button
                className="scp-1072348"
                onClick={i?.go}
                style={dc.css(
                  `display:flex;align-items:center;gap:10px;padding:8px 11px;border-radius:8px;border:none;background:${dc.s(i?.bg)};color:${dc.s(i?.fg)};font-size:12px;font-weight:500;cursor:pointer;text-align:left`,
                )}
              >
                <i className={`ph ${dc.s(i?.icon)}`} style={{ fontSize: '14px' }}></i>
                {dc.t(i?.label)}
              </button>
            </Fragment>
          ))}{' '}
        </nav>{' '}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          {' '}
          {m.setSectionProfile ? (
            <>
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '18px 20px',
                }}
              >
                {' '}
                <div style={{ fontSize: '13px', fontWeight: '500' }}>Profile</div>{' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginTop: '16px' }}>
                  {' '}
                  <div
                    style={dc.css(
                      `width:52px;height:52px;border-radius:50%;background:var(--surface);background-image:${dc.s(m.avatarBg)};background-size:cover;background-position:center;border:1px solid color-mix(in srgb, var(--acc-fill) 45%, transparent);color:var(--acc);display:flex;align-items:center;justify-content:center;font-size:19px;font-weight:600`,
                    )}
                  >
                    {dc.t(m.avatarInitialsSet)}
                  </div>{' '}
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '500' }}>Omichael Nhamburo</div>
                    <div style={{ fontSize: '11.5px', color: 'var(--muted2)' }}>
                      omichael@pointfiveinc.com
                    </div>
                  </div>{' '}
                  <div style={{ flex: '1' }}></div>{' '}
                  <input
                    type="file"
                    accept="image/png,image/jpeg,image/webp"
                    id="pf-avatar-file"
                    style={{ display: 'none' }}
                    aria-label="Choose a profile photo"
                    onChange={(ev) => {
                      const file = ev.target.files?.[0];
                      ev.target.value = '';
                      if (!file || !m.profileSetAvatar) return;
                      const reader = new FileReader();
                      reader.onload = () => m.profileSetAvatar?.(String(reader.result));
                      reader.readAsDataURL(file);
                    }}
                  />
                  <button
                    onClick={() => document.getElementById('pf-avatar-file')?.click()}
                    aria-label="Change profile photo"
                    className="scp-6bc9eb5"
                    style={{
                      fontSize: '11.5px',
                      padding: '7px 14px',
                      borderRadius: '99px',
                      border: '1px solid var(--l14)',
                      background: 'transparent',
                      color: 'var(--text-mid)',
                      cursor: 'pointer',
                    }}
                  >
                    Change photo
                  </button>{' '}
                </div>{' '}
                <div
                  style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginTop: '18px' }}
                >
                  {' '}
                  <div>
                    <div style={{ fontSize: '11px', color: 'var(--muted)', marginBottom: '5px' }}>
                      Display name
                    </div>
                    <input
                      value={dc.v(m.profileName)}
                      onChange={(e) => m.profileSetName?.(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '9px 12px',
                        borderRadius: '9px',
                        border: '1px solid var(--l10)',
                        background: 'var(--fill)',
                        color: 'var(--text)',
                        fontSize: '12.5px',
                        outline: 'none',
                      }}
                      aria-label="Display name"
                    />
                  </div>{' '}
                  <div>
                    <div style={{ fontSize: '11px', color: 'var(--muted)', marginBottom: '5px' }}>
                      Public handle
                    </div>
                    <input
                      value={dc.v(m.profileHandle)}
                      onChange={(e) => m.profileSetHandle?.(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '9px 12px',
                        borderRadius: '9px',
                        border: '1px solid var(--l10)',
                        background: 'var(--fill)',
                        color: 'var(--text)',
                        fontSize: '12.5px',
                        outline: 'none',
                      }}
                      aria-label="Public handle"
                    />
                  </div>{' '}
                  <div>
                    <div style={{ fontSize: '11px', color: 'var(--muted)', marginBottom: '5px' }}>Email</div>
                    <input
                      value={dc.v(m.profileEmail)}
                      aria-describedby="pf-email-note"
                      title="Email is the sign-in identity — it does not change here"
                      style={{
                        width: '100%',
                        padding: '9px 12px',
                        borderRadius: '9px',
                        border: '1px solid var(--l10)',
                        background: 'var(--fill)',
                        color: 'var(--text)',
                        fontSize: '12.5px',
                        outline: 'none',
                      }}
                      aria-label="Email"
                      readOnly
                    />
                  </div>{' '}
                  <div>
                    <div style={{ fontSize: '11px', color: 'var(--muted)', marginBottom: '5px' }}>
                      Base currency
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '9px 12px',
                        borderRadius: '9px',
                        border: '1px solid var(--l8)',
                        background: 'transparent',
                        fontSize: '12.5px',
                        color: 'var(--text2)',
                      }}
                    >
                      USD — US Dollar
                      <i
                        className="ph ph-caret-down"
                        style={{ fontSize: '11px', color: 'var(--muted2)' }}
                      ></i>
                    </div>
                  </div>{' '}
                </div>{' '}
                <button
                  className="scp-9d13bde"
                  onClick={m.profileSave}
                  style={{
                    marginTop: '16px',
                    fontSize: '12px',
                    fontWeight: '500',
                    padding: '8px 18px',
                    borderRadius: '99px',
                    border: '1px solid color-mix(in srgb, var(--slate-fill) 50%, transparent)',
                    background: 'color-mix(in srgb, var(--slate-fill) 10%, transparent)',
                    color: 'var(--slate)',
                    cursor: 'pointer',
                  }}
                >
                  Save changes
                </button>{' '}
              </div>{' '}
            </>
          ) : null}{' '}
          {m.setSectionNotif ? (
            <>
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '18px 20px',
                }}
              >
                {' '}
                <div style={{ fontSize: '13px', fontWeight: '500' }}>Notification preferences</div>{' '}
                <div style={{ fontSize: '11.5px', color: 'var(--muted2)', marginTop: '3px' }}>
                  Choose which alerts reach you and how.
                </div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '12px' }}>
                  {' '}
                  {(m.setPrefs ?? []).map((p, i177) => (
                    <Fragment key={i177}>
                      {' '}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '14px',
                          padding: '13px 0',
                          borderTop: '1px solid var(--l5)',
                        }}
                      >
                        {' '}
                        <div style={{ flex: '1' }}>
                          <div style={{ fontSize: '12.5px', fontWeight: '500' }}>{dc.t(p?.label)}</div>
                          <div style={{ fontSize: '11px', color: 'var(--muted2)', marginTop: '2px' }}>
                            {dc.t(p?.desc)}
                          </div>
                        </div>{' '}
                        <Toggle
                          trackBg={p?.trackBg}
                          knobBg={p?.knobBg}
                          knob={p?.knob}
                          onClick={p?.toggle}
                          aria-label={dc.a(p.toggleLabel ?? p.name ?? p.label ?? 'Toggle')}
                        />{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
            </>
          ) : null}{' '}
          {m.setSectionOther ? (
            <>
              {' '}
              <SettingsSection m={m} />{' '}
            </>
          ) : null}{' '}
        </div>{' '}
      </div>
      <span hidden id="pf-email-note">
        Email is the sign-in identity — it does not change here.
      </span>
    </div>
  );
}
